import { IconProps } from '../icon-props-interface';
import '../icons.scss';

const IconNewTab = ({ color = 'var(--color-accent-1)' }: IconProps): JSX.Element => (
    <div className="icon-block">
        <svg width="8"
             height="8"
             viewBox="0 0 8 8"
             fill="none"
             xmlns="http://www.w3.org/2000/svg">
            <path d="M5 0C4.72344 0 4.5 0.223437 4.5 0.5C4.5 0.776563 4.72344 1 5 1H6.29219L3.14687 4.14687C2.95156 4.34219 2.95156 4.65938 3.14687 4.85469C3.34219 5.05 3.65937 5.05 3.85469 4.85469L7 1.70781V3C7 3.27656 7.22344 3.5 7.5 3.5C7.77656 3.5 8 3.27656 8 3V0.5C8 0.223437 7.77656 0 7.5 0H5ZM1.25 0.5C0.559375 0.5 0 1.05938 0 1.75V6.75C0 7.44063 0.559375 8 1.25 8H6.25C6.94063 8 7.5 7.44063 7.5 6.75V5C7.5 4.72344 7.27656 4.5 7 4.5C6.72344 4.5 6.5 4.72344 6.5 5V6.75C6.5 6.8875 6.3875 7 6.25 7H1.25C1.1125 7 1 6.8875 1 6.75V1.75C1 1.6125 1.1125 1.5 1.25 1.5H3C3.27656 1.5 3.5 1.27656 3.5 1C3.5 0.723437 3.27656 0.5 3 0.5H1.25Z"
                  fill={color}/>
        </svg>
    </div>
);

export default IconNewTab;
